import Controller, { inject as controller } from '@ember/controller';
import { computed } from '@ember/object';
import isEqual from 'lodash.isequal';
import NewsletterSetupController from 'cio/pods/broadcasts/newsletter/setup/controller';
import TemplateModel from 'cio/models/template';
import SubscriptionCenterService from 'cio/services/subscription-center';
import { inject as service } from '@ember/service';
import NewsletterModel from 'cio/models/newsletter';
import AuthService from 'cio/services/auth';

export default class IndexController extends Controller {
  @service auth!: AuthService;
  @service subscriptionCenter!: SubscriptionCenterService;

  declare model: NewsletterModel;

  @controller('broadcasts.newsletter.setup') newsletterSetupController!: NewsletterSetupController;

  @computed('model.{templatesMissingContent,templatesMissingSubject}')
  get missingContent() {
    let { templatesMissingContent, templatesMissingSubject } = this.model;

    if (templatesMissingContent && templatesMissingSubject) {
      return 'a subject line and content';
    } else if (templatesMissingContent) {
      return 'content';
    } else if (templatesMissingSubject) {
      return 'a subject line';
    } else {
      return;
    }
  }

  get isMissingLanguagesAcrossTests() {
    let { testVariations, languageVariations } = this.model;
    let validTestGroups = testVariations.map((template: TemplateModel) => template.testGroupId);

    if (languageVariations.length < 1) {
      return false;
    }

    // group language variations by testGroupId
    let testGroups = languageVariations.reduce((groups: Record<string, string[]>, variation: TemplateModel) => {
      if (!validTestGroups.includes(variation.testGroupId)) {
        return groups;
      }

      if (!groups[variation.testGroupId]) {
        groups[variation.testGroupId] = [];
      }

      groups[variation.testGroupId].push(variation.language);
      return groups;
    }, {});

    let keys = Object.keys(testGroups);
    let doesAnyTestGroupContainDifferentLanguageVariations = keys.some((key, index) => {
      if (index === 0) {
        return false;
      }

      let previousKey = keys[index - 1];

      return !isEqual(testGroups[previousKey].sort(), testGroups[key].sort());
    });

    return doesAnyTestGroupContainDifferentLanguageVariations || testVariations.length !== keys.length;
  }

  get hasReadOnlyPermission() {
    return !this.auth.hasPermission('journeys/newsletters/edit');
  }
}
